/**
 * 组织架构模块
 */

import React, { FC, useMemo } from 'react';
import { ProDetailList } from '@bedrock/eed-react';
import {
  FormModule,
  FormDescriptions,
  FormItemActualControllerDetailList,
  FormItemDepartmentName,
  FormItemDepartmentHead,
  FormItemJobContent,
  FormItemDepartmentMemberCount,
  FormItemConnectedGame,
  FormItemAttachmentFile,
} from '@purchase/supplier';

const OrganizationStructureModule: FC<{
  formDetail: any;
}> = ({ formDetail }) => {
  const organizationCount = useMemo(
    () =>
      formDetail?.vendorOrganizationInfo?.vendorOrganizationDetails?.length ??
      0,
    [formDetail]
  );

  return (
    <FormModule
      title="组织架构"
      titleCount={organizationCount}
      proCardProps={{
        expandable: true,
        defaultExpanded: organizationCount > 0,
      }}
    >
      <FormItemActualControllerDetailList
        name={['vendorOrganizationInfo', 'vendorOrganizationDetails']}
      >
        <ProDetailList.Item
          label="#"
          name="#"
          meta={{ columnProps: { width: 50, fixed: true } }}
        >
          {(value, record, index) => index + 1}
        </ProDetailList.Item>
        <FormItemDepartmentName
          label="部门名称"
          name="departmentName"
          meta={{
            columnProps: {
              width: 200,
              className: 'font-semibold',
              fixed: true,
            },
          }}
        />
        <FormItemDepartmentHead
          label="部门负责人"
          name="departmentHead"
          meta={{ columnProps: { width: 140 } }}
        />
        <FormItemJobContent
          label="主要负责工作内容"
          name="jobContent"
          meta={{ columnProps: { width: 300 } }}
        />
        <FormItemDepartmentMemberCount
          label="部门人数"
          name="departMemberCount"
          meta={{ columnProps: { width: 120 } }}
        />
        <FormItemConnectedGame
          label="是否是网易游戏直接对接部门"
          name="connectedGame"
          meta={{ columnProps: { width: 240 } }}
        />
        <FormItemConnectedGame
          label="是否网易专属对接部门"
          name="neteaseExclusiveDept"
          meta={{ columnProps: { width: 240 } }}
        />
      </FormItemActualControllerDetailList>

      {/* 组织架构图（原"组织架构附件"更名） */}
      <FormDescriptions labelStyle={{ width: 180 }} className="mt-4 mb-0">
        <FormItemAttachmentFile
          label="组织架构图"
          name={['vendorOrganizationInfo', 'departAttachments']}
        />
      </FormDescriptions>
    </FormModule>
  );
};

export default OrganizationStructureModule;
